export default "__VITE_ASSET__61017b6c__"